import React from 'react';
import cn from 'classnames';
import * as styles from './CountBox.module.scss';

export default function CountBox({ total, active = true }) {
  return <span className={cn(styles.count, active && styles.active)}>{total}</span>;
}
